import { Component, OnInit, Input, ViewRef, ViewChild, ElementRef, ViewContainerRef, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { NgxCmModalContext } from '../../models';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ngx-cm-modal-container',
  templateUrl: 'ngx-modal-container.component.html',
  styleUrls: ['ngx-modal-container.component.scss']
})
export class NgxModalContainerComponent implements OnInit, AfterViewInit {

  _componentFactory;
  @Input()
  set ComponentFactory(factory) {
    this._componentFactory = factory;
    this.Initialize();
  };
  get ComponentFactory() {
    return this._componentFactory;
  }

  @Input()
  Size = 'md';

  @Input()
  TopBottomSpace = 25;

  _modalContext;
  @Input()
  set ModalContext(context) {
    this._modalContext = context;
    this.Initialize();
  };
  get ModalContext(): NgxCmModalContext {
    return this._modalContext;
  }

  @Output()
  Close = new EventEmitter();

  ModalWidth = 400;
  ModalHeight = null;
  ModalMaxHeight = 0;

  @ViewChild('container', { read: ViewContainerRef, static: true }) container: ViewContainerRef;

  // start the loader
  loading = true;

  outputSubscriptions: Subscription[] = [];

  constructor() { }

  ngOnInit() {
  }

  Initialize() {
    if (this.ModalContext && this.ComponentFactory) {
      let componentRef = this.container.createComponent(this.ComponentFactory);

      // stop the loader
      this.loading = false;

      // set inputs
      this.ModalContext.ComponentContext.Input.forEach(i => {
        componentRef.instance[i.Name] = i.Value;
      });

      // set outputs
      this.ModalContext.ComponentContext.Output.forEach(o => {
        this.outputSubscriptions.push(componentRef.instance[o.Name].subscribe(value => {
          o.Trigger(value);
          if (o.CloseOnEmit) {
            this.closeModal();
            this.outputSubscriptions.forEach(s => s.unsubscribe());
          }
        }));
      });

      this.ModalHeight = this.ModalContext.Height == 'full' ? window.innerHeight - (this.TopBottomSpace * 2) : null;
      this.ModalMaxHeight = window.innerHeight - (this.TopBottomSpace * 2);
      this.ModalWidth = this.ModalContext.Size == 'md' ? 600 : this.ModalContext.Size == 'sm' ? 400 : this.ModalContext.Size == 'lg' ? 1200 : parseInt(this.ModalContext.Size);
    }
  }

  ngAfterViewInit() { }

  closeModal() {
    this.Close.emit();
  }

}
